import _defaultMessages from './translations/en-GB.json';

export const defaultMessages = _defaultMessages;
